import { render, staticRenderFns } from "./vmCommissionLimit.vue?vue&type=template&id=6a813f2b&scoped=true&"
import script from "./vmCommissionLimit.ts?vue&type=script&lang=ts&"
export * from "./vmCommissionLimit.ts?vue&type=script&lang=ts&"
import style0 from "./vmCommissionLimit.vue?vue&type=style&index=0&id=6a813f2b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.0_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._dqvcgk3en6wwbxrhlb6nnpgame/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a813f2b",
  null
  
)

export default component.exports